/**
 * ValidateName Component
 *
 * Features:
 * - Validates the user's name before allowing them to continue.
 * - Shows a confirmation dialog if the name does not meet requirements.
 * - Uses Redux to get user info and i18next for translations.
 * - Utilizes Material-UI Dialog and Button components for UI.
 */
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';

import classes from './ValidateName.module.css';

const ValidateName = props => {
  const { t } = useTranslation(['ui']);
  const userInfo = useSelector(state => state.userInfo);

  const validateNameBtn = () => {
    props.confirmName(); // Calls the confirmName prop function
  };

  return (
    <Dialog
      open={props.open}
      fullWidth
      maxWidth="sm"
      className={classes.dialogcontainer}
    >
      <div className={classes.textContainer}>
        <p className={classes.text}>{t('earning_diploma')}</p>
        <p className={classes.text}>¡Sigue así!</p>
        <p className={classes.textAlert}>{t('finish_course')}</p>
      </div>
      <div className={classes.userNameContainer}>
        <p className={classes.userName}>
          {userInfo.data.nombre} {userInfo.data.apellido}
        </p>
      </div>
      <p className={classes.descriptionText}>
        {t('want_your_name')}
      </p>
      <div className={classes.btnsContainer}>
        <Button
          className={classes.changeNameBtn}
          component="a"
          href={`${process.env.REACT_APP_API_PATH_GENERAL_CAMPUS}/myProfile/info`}
        >
          {t('make_adjustment')}
        </Button>
        <Button
          className={classes.acceptNameBtn}
          onClick={validateNameBtn}
        >
          {t('my_name_is_correct')}
        </Button>
      </div>
    </Dialog>
  );
};

ValidateName.propTypes = {
  /**
   * Function to be called when the name is confirmed
   */
  open: PropTypes.bool, // Controls the visibility of the dialog
  confirmName: PropTypes.func.isRequired
};

ValidateName.defaultProps = {
  open: false,
  confirmName: () => {}
};

export default ValidateName;
